import { z } from 'zod';

import { MatchingRecord } from '@eluve/utils';

import { UserFileTypesEnum } from './types';

export const UserFileTypesLookup = {
  SIGNATURE: 'SIGNATURE',
  MEDICAL_CODE_CONFIGS: 'MEDICAL_CODE_CONFIGS',
  CHAT_DOCUMENT: 'CHAT_DOCUMENT',
  BILLING_CODE: 'BILLING_CODE',
  PDF_FORM_TEMPLATE: 'PDF_FORM_TEMPLATE',
  PDF_FORM_FILLED: 'PDF_FORM_FILLED',
} as const satisfies MatchingRecord<UserFileTypesEnum>;

export const userFileTypesSchema = z.nativeEnum(UserFileTypesLookup);
